<script>
export default {
    props: {
        label: {
            type: String,
            default: ""
        },
        placeholder: {
            type: String,
            default: ""
        },
        value: {
            type: [String, File]
        }
    },
    methods: {
        updateValue: function(value) {
            this.$emit('input', value);
        }
    }
}
</script>

<style lang="scss">
@import '@styles/mixins.scss';
.input {
    .input-field {
        background-color: #f2f2f2;
        border: 1px solid #f2f2f2;
        outline: none;
        padding: 5px 10px;
        width: 100%;
        height: 40px;
        &:focus {
            background-color: white;
            border: 1px solid black;
        }
        &::placeholder {
            font-size: 16px;
            vertical-align: middle;
            color: rgba(0, 0, 0, 0.4);
        }
    }
    label {
        display: block;
        min-height: 25px;
        @media (max-width: grid-breakpoint(sm)) {
            min-height: 0;
        }
    }
}
</style>